export type Maybe<T> =
  | {
      value: T
      error: undefined
    }
  | {
      value: undefined
      error: Error
    }
